module.exports = __webpack_public_path__ + "img/14_life_below_water.ad45a8b0.svg";